const properties = {
  top_tab_title: 'Property Configuration',
  subheadings: {
    details: 'Details',
    settings: 'Settings',
    branding: 'Brand Management',
    location: 'Address',
  },
  labels: {
    add_contact: 'Add Existing Contact',
    lookup_location: 'Address Lookup',
    require_tags: 'Require Tags',
    enable_permit_portal: 'Enable Permit Portal',
    address_switch: 'Use Inherited Branding For Header & Footer',
    filter_by_group: 'Filter By Property Group',
    disable_tows_alert: 'Towing is temporarily prohibited',
    no_group: 'No Group',
    require_tag_photo: 'Require Tag Photo',
    notify_pending_permit: 'Notify PM of New Pending Permit',
  },
  helpers: {
    gate_code: 'Access code for the property gate',
    disable_fmc: 'A Find My Car website is enabled for this company. You can disable it for this property if you do not want to use it.',
    disable_fmc_tenant_disabled: 'Find My Car is not enabled for this company',
    notify_manager:
      'Notify Property Manager whenever a job is created or updated for this property',
    require_signature:
      'Require a digital signature from the property manager on all new job requests',
    enable_permit_portal:
      'Allow residents to purchase or register for permits online',
    logo_url:
      'The icon logo will be used in the browser tab. The Traxero "T" logo as seen in the tab of this page will be used if left blank.',
    banner_logo_url:
      'The {{entity}} name will be used if left blank. Use the slider on the right to fit your logo into the header.',
    active_branding: 'Choose an available theme or create a new one',
    address_switch: 'Use the contact info and logo of the parent entity',
    filter_labels: 'Add custom labels to filter and sort your properties by',
    disable_tows: 'Temporarily prohibit towing at this property',
    enable_patrols:
      'This property may be periodically patrolled without an explicit request',
    require_tag_photo:
      'Require a photo of the tag on the vehicle when a vehicle is tagged on this property',
    notify_pending_permit:
      'Notify the property manager when a new permit is pending approval',
  },
  preview: {
    permit_portal: {
      title: 'Permit Registration Website',
      button: 'Submit Registration',
      agree: 'Return to Registration',
      formCardTitle: 'Permit Parking Registration',
      tandc_title: 'Terms and Conditions',
      tandc_1: 'By submitting this form, you agree to the',
      tandc_2: 'terms and conditions',
      tandc_3: 'of the permit',
      your_information: 'Your Information',
    },
    fmc: {
      title: 'Find My Car Website',
      make_model: 'Make & Model',
      plate: 'Plate',
      vin: 'VIN',
      alert_title: '1 Vehicle Found',
      yourCarGotTowed: 'Your vehicle was towed to',
      button: 'Find My Car',
    },
  },
  importWizard: {
    columnMappings: 'Column Mappings',
    discardedRows: 'Discarded Rows',
    fieldInformation: 'Field Information',
    generate_data: 'Generate Data',
    imported_data: 'Imported Value',
    your_data: 'Your Data',
    optional_field: 'Optional Field',
    required_field: 'Required Field',
    autofill_address: 'Autofill Address',
    leave_blank: 'Leave Blank',
    mapped_vehicle: 'Mapped Vehicle',
    combined_field: 'Mutiple Fields',
    auto_generated: 'Auto-Generated',
    duplicate_records: 'Duplicate Records Removed: {{count}}',
    csvField: 'Column',
    trailingCharacters: 'Trailing Characters',
    combinedValue: 'Combined Value',
    property_address: 'Property Address',
    fieldList: {
      title: 'Field List',
      progress:
        '{{confirmedRequired}} out of {{totalRequired}} required fields mapped ({{confirmedTotal}} out of {{totalFields}} total)',
      permit_fields: 'Permit Fields',
      vehicle_fields: 'Vehicle Fields',
      contact_fields: 'Contact Fields',
    },
    preview_title: 'Permit Import Preview',
    total_records: 'Total Records: {{count}}',
    failedImports: {
      title:
        'Some permits failed to import. Please review the failed records and resubmit them. ({{count}} remaining)',
      row_error: 'Row {{row}}: {{error}}',
    },
    validationWidget: {
      generate_data: 'All permits will be imported with the value below',
      remaining_errors: 'Remaining Validation Errors: {{count}}',
      original_value: 'Original Value',
      new_value: 'New Value',
      update_value: 'Update Value',
      replace_all: 'Replace All',
    },
    processingVehicleData:
      'Processing Vehicle Data. This process may take a while for large data sets.',
    saveColumnMappingsHelper:
      'Save your column mappings for this data source for future use: {{name}}',
    downloadDiscardedRowsHelper:
      'All of your discarded rows will be downloaded as a CSV file.',
    uploadCSVHelper: 'Upload a CSV file with the permits you want to import',
    downloadCSVTemplateHelper:
      'If you prefer to map your data in your spreadsheet editor, you can import our CSV template to copy your permit data into.  For best results, do not modify the first two rows of the CSV template.',
    downloadCSVTemplateButton: 'Download CSV Template',
    noSavedMappings: 'No Saved Mappings',
    savedMappingsHelper:
      'If you have previously imported data from this source, select your saved mapping to use for this import',
    saveMappingNameExists: 'Mapping name already exists',
    steps: {
      upload: 'Upload and Define',
      map: 'Map and Validate',
      preview: 'Review and Import',
    },
    buttons: {
      upload_submit: 'Continue to Mapping',
      map_submit: 'Complete Mapping and Preview',
      upload_cancel: 'Return to Permits',
      map_cancel: 'Return to Upload',
      preview_cancel: 'Return to Mapping',
      discard_failed_permit: 'Discard Failed Permit',
      clear_mapping: 'Clear Mapping',
      confirm_mapping: 'Confirm Mapping',
      validate_all: 'Validate All Mapped Fields',
      complete_submit: 'Import Additional Permits',
      map_vehicle_data: 'Map Vehicle Data',
      add_combined_field: '+ Combine Additional Field',
      map_combined_fields: 'Map Combined Fields',
    },
    permitTypeLabel: 'Permit Type: {{name}}',
    importFileLabel: 'Import File: {{name}}',
    remaining_errors: 'Remaining Validation Errors: {{count}}',
    alerts: {
      csv_import_tips: {
        title: 'CSV Import Tips',
        p1: 'If you have errors such as too many or not enough fields, you can fix your data in the next step, or you can modify the data in your spreadsheet and re-upload it.',
        p2: 'Usually, these errors are caused by commas in your data cells or by having rows that are longer than the header row.',
        p3: 'First check your data and make sure that there is no data in columns which do not have a header.',
        p4: 'If you have commas in your data, you can remove them or use a different delimiter such as | when you export your CSV.',
      },
      template_recognized: {
        title: 'CSV Template Recognized',
        p1: 'The imported CSV template has been recognized.',
        p2: 'You can now proceed to validate and import your data.',
      },
      perfect_parse: {
        title: 'CSV Data Imported',
        p1: 'Your CSV data has been imported without encountering any formatting issues!',
        p2: 'You can now proceed to map your data to the system fields.',
      },
      import_report: {
        title: 'Import Complete',
        p1: 'You have successfully imported {{successCount}} permits.',
        p2: 'If you want to download a PDF or CSV of imported permits, use the three-dot menu in the top right corner of this panel.',
      },
      discarded_rows: {
        title: 'Discarded Rows',
        p1: 'There were {{discardedCount}} rows that were discarded.  You can download the rows you discarded as a CSV file for your records below',
      },
      welcome: {
        title: 'Welcome to the Permit Migration Wizard',
        p1: 'In the first step, you will select the type of permits you want to import and upload your existing permit data.',
        p2: 'You can select an existing permit type or create a new one by selecting the "Create New Permit Type" option from the dropdown below.',
      },
      invalid_values: {
        title: 'Invalid Values Detected',
        p1: 'Some values in this column do not meet the required format or constraints.',
        p2: 'Please review and correct the data before proceeding.',
      },
      validation_success: {
        title: 'Validation Successful',
        p1: 'All values for this field are valid.',
        p2: 'You can proceed to the next field.',
      },
      map_tutorial: {
        title: 'Field Mapping',
        p1: 'In this step, we will map and validate your data against our system fields and requirements.',
        p2: 'You can select a system field from the left panel and assign it a column from your imported data using the dropdown menu above. Some fields may have been mapped automatically based on the column name. You will still need to validate the data and correct any errors.',
        p3: 'If we made a mistake, you can select the field and click "Clear Mapping". You will then be able to map it manually.',
        p4: 'Once you have validated the data for a field, click "Confirm Mapping". to proceed to the next field.',
        p5: 'Detailed information about how to handle each field can be found in the "Field Details" section on the right.',
        p6: 'In addition to your fields, the dropdown at the top of this column also provides a few actions depending on the field.',
        p7: 'Generate Data: You can import all of your permits with a specific value for this field.',
        p8: 'Autofill Address: You can autofill the address for this field with the property address.',
        p9: 'Smart Map Vehicle: If you have a single column which contains two or more of the following vehicle data types: Make, Model, Color, or Year, you can extract this data into separate fields.',
        p10: 'Leave Blank: You can leave this field blank for all permits.',
      },
      mapping_complete: {
        title: 'Mapping Complete',
        p1: 'You have successfully mapped all of the fields in your imported data.',
        p2: 'You can now proceed to review your data and confirm the import.',
      },
      duplicate_records: {
        title: 'Duplicate Records Removed',
        p1: 'We discarded {{discardedCount}} duplicate rows from your data.  You can download any discarded rows as a CSV file after you import your data.',
      },
      extract_vehicle_instructions: {
        title: 'Extracting Vehicle Data',
        p1: 'If you have a single column which contains two or more of the following vehicle data types: Make, Model, Color, or Year, you can extract this data into separate fields.',
        p2: 'You can select a the field from your data which contains the vehicle data and click the "Extract" button. The data will be extracted into separate fields and validated.',
        p3: 'If the data is not formatted correctly, you will be given the opportunity to correct the data or map it to the correct fields manually.',
      },
      fields: {
        permitNumber: {
          info: {
            p1: 'If you have assigned specific permit numbers, you can provide them here',
          },
          optional: {
            p1: 'If you do not assign permit numbers, you can select "Leave Blank" from the dropdown menu and we will assign each permit a unique number automatically in our system',
          },
        },
        status: {
          info: {
            p1: 'This field describes the current status of the permit',
            p2: 'Valid permit statuses: Active, Disabled, Expired, Pending Payment, and Pending Approval',
          },
          required: {
            p1: 'This field must contain a value to create a permit',
            p2: "If the permit status is not available, you can use 'Generate Data' to autofill a value for all your permits.",
            p3: "We recommend using 'Active' as the status for imported permits.",
          },
        },
        startTime: {
          info: {
            p1: 'The start time is the first day the permit is valid',
            p2: 'In the case of temporary permits, it can also contain a time',
          },
          required: {
            p1: 'This field must contain a value to create a permit',
            p2: "If the permit start time is not available, you can use 'Generate Data' to autofill a value for all your permits.",
          },
        },
        endTime: {
          info: {
            p1: 'The end time is the last day the permit is valid',
            p2: 'In the case of temporary permits, it can also contain a time',
          },
          required: {
            p1: 'This field must contain a value to create a permit',
            p2: "If the permit end time is not available, you can use 'Generate Data' to autofill a value for all your permits.",
          },
        },
        make: {
          info: {
            p1: 'If the issued permit is for a specific vehicle, you can provide the make here',
            p2: 'We will attempt to validate the make against the most common vehicle manufacturers provided by the NHTSA',
          },
          optional: {
            p1: 'If you do not have make information, you can select "Leave Blank" from the dropdown menu and we will assign each permit a make of "Unknown"',
          },
        },
        model: {
          info: {
            p1: 'If the issued permit is for a specific vehicle, you can provide the model here',
            p2: 'A comprehensive list of vehicle models for the provided make is available in the dropdown menu',
          },
          optional: {
            p1: 'If you do not have model information, you can select "Leave Blank" from the dropdown menu and we will assign each permit a model of "Unknown"',
          },
        },
        year: {
          info: {
            p1: 'If the issued permit is for a specific vehicle, you can provide the year here',
          },
          optional: {
            p1: 'If you do not have year information, you can select "Leave Blank" from the dropdown menu and we will assign each permit a year of "Unknown"',
          },
        },
        color: {
          info: {
            p1: 'If the issued permit is for a specific vehicle, you can provide the color here',
            p2: 'We will attempt to validate the color against common vehicle colors provided by the NHTSA.  If the vehicle color is not recognized, you can choose the closest match from the dropdown menu',
          },
          optional: {
            p1: 'If you do not have color information, you can select "Leave Blank" from the dropdown menu and we will assign each permit a color of "Unknown"',
          },
        },
        vin: {
          info: {
            p1: 'If the issued permit is for a specific vehicle, you can provide the Vehicle Identification Number (VIN) here',
          },
          optional: {
            p1: 'If you do not have VIN information, you can select "Leave Blank" from the dropdown menu and we will assign each permit a VIN of "Unknown"',
          },
        },
        plate_number: {
          info: {
            p1: 'If the issued permit is for a specific vehicle, you can provide the license plate number here',
            p2: 'License plate information can be used by the tower in place of a physical permit',
          },
          optional: {
            p1: 'If you do not have license plate number information, you can select "Leave Blank" from the dropdown menu and we will assign each permit a plate number of "Unknown"',
          },
        },
        plate_state: {
          info: {
            p1: 'If the issued permit is for a specific vehicle, you can provide the license plate state here',
          },
          optional: {
            p1: 'If you do not have license plate state information, you can select "Leave Blank" from the dropdown menu and we will assign each permit a plate state of "Unknown"',
          },
        },
        contact_name: {
          info: {
            p1: 'This field holds the name of the permit holder',
          },
          required: {
            p1: 'This field must contain a value to create a permit',
            p2: "If the permit holder's name is not available, you can use 'Generate Data' to fill in every row with a generic name like 'Resident' or 'Visitor'",
          },
        },
        street: {
          info: {
            p1: 'This field holds the street address of the permit holder',
          },
          optional: {
            p1: 'If you would like to autofill the address of this property, you can select "Autofill Address" from the dropdown menu',
            p2: 'Alternatively, if you do not want to list an address, you can select "Leave Blank"',
          },
        },
        city: {
          info: {
            p1: 'This field holds the city of the permit holder',
          },
          optional: {
            p1: 'If you would like to autofill the city of this property, you can select "Autofill Address" from the dropdown menu',
            p2: 'Alternatively, if you do not want to list a city, you can select "Leave Blank"',
          },
        },
        stateCode: {
          info: {
            p1: 'This field holds the state or province of the permit holder',
          },
          optional: {
            p1: 'If you would like to autofill the state of this property, you can select "Autofill Address" from the dropdown menu',
            p2: 'Alternatively, if you do not want to list a state, you can select "Leave Blank"',
          },
        },
        postalCode: {
          info: {
            p1: "This field holds the postal code (ZIP code) of the permit holder's address",
          },
          optional: {
            p1: 'If you would like to autofill the postal code of this property, you can select "Autofill Address" from the dropdown menu',
            p2: 'Alternatively, if you do not want to list a postal code, you can select "Leave Blank"',
          },
        },
        unit: {
          info: {
            p1: 'This field holds the unit, suite, or apartment number of the permit holder',
          },
          optional: {
            p1: 'If your address does not have a unit, suite, or apartment number, you can select "Leave Blank"',
          },
        },
        primaryEmail: {
          info: {
            p1: 'This field holds the email address of the permit holder',
            p2: 'If provided, you will be able to configure automated email notifications for this permit holder',
          },
          optional: {
            p1: 'If you do not have email information, you can select "Leave Blank" from the dropdown menu',
            p2: 'If provided, the email address must be valid',
          },
        },
        primaryPhone: {
          info: {
            p1: 'This field holds the phone number of the permit holder',
            p2: 'If provided, you will be able to configure automated SMS notifications for this permit holder',
          },
          optional: {
            p1: 'If you do not have phone number information, you can select "Leave Blank" from the dropdown menu',
            p2: 'If provided, the phone number must be a valid 10 digit phone number',
          },
        },
      },
    },
  },
};

export default properties;
